import {
    IonBackButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    isPlatform,
  } from "@ionic/react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { RootState } from "../../store/rootReducer";
import { FileTypeDetailForm } from "./components/FileTypeDetailForm";
  
  export const FileTypeDetail = () => {
    const { id }: { id: string } = useParams();
    
    return (
      <IonPage>
        <IonHeader class="ion-no-border">
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton
                text={isPlatform("ios") ? "Tipos de archivos" : ""}
                defaultHref={`/app/tic/tipos-de-archivos/`}
                color="light"
              />
            </IonButtons>
            <IonTitle>Detalle</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <FileTypeDetailForm idFileType={id}/>
        </IonContent>
      </IonPage>
    );
  };
  